<template>
    <div
        class="box"
        :class="[
            `radius_${radius}`,
            `padding_${padding}`,
            `elevation_${elevation}`,
            paddingVertical && `padding_vertical_${paddingVertical}`,
            animation && `animation_${animation}`,
            noTopRadius && 'radius_noTop',
            noBottomRadius && 'radius_noBottom',
            overflowHidden && 'hidden',
        ]">
        <div v-if="disabled" class="disabled-overlay" />
        <div v-if="title" class="box-title" :class="[`color_${titleBackgroundColor}`]">
            <Icon v-if="titleIcon" :type="titleIcon" /> {{ title }}
        </div>
        <div class="box-content" :class="{ fullHeight }" :role="ariaRole">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
    import {
        Padding,
        Radius,
        Animation,
        TitleBackgroundColor,
        Elevation,
    } from './Box.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'Box',
        components: { Icon },
        props: {
            padding: {
                type: String as PropType<Padding>,
                default: 'm',
            },
            paddingVertical: {
                type: String as PropType<Padding>,
                default: undefined,
            },
            radius: {
                type: String as PropType<Radius>,
                default: 's',
            },
            animation: {
                type: String as PropType<Animation>,
                default: 'none',
            },
            elevation: {
                type: String as PropType<Elevation>,
                default: '10',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            noTopRadius: {
                type: Boolean,
                default: false,
            },
            noBottomRadius: {
                type: Boolean,
                default: false,
            },
            title: String,
            titleBackgroundColor: {
                type: String as PropType<TitleBackgroundColor>,
                default: 'yellow',
            },
            titleIcon: String as PropType<IconType>,
            fullHeight: Boolean,
            overflowHidden: Boolean,
            ariaRole: {
                type: String,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Box.scss';
</style>
